// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Assets/Fonts/Mulish-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Assets/Fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --theme1: #244394;
  --theme2: #f15822;
  --cyan: #1ea6d1;
  --white: #ffffff;
  --grey: #1f1f1f;
  --black: #060b18;
}

@font-face {
  font-family: "Mulish", sans-serif;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 400;
}

@font-face {
  font-family: "Poppins", sans-serif;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

body {
  margin: 0;
  font-family: "Poppins", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px !important;
}

.font12 {
  font-size: 12px;
}

.font16 {
  font-size: 1.14em;
}

.font18 {
  font-size: 1.29em;
}

.font20 {
  font-size: 1.43em;
}

.colorTheme1 {
  color: var(--theme1);
}

.colorTheme2 {
  color: var(--theme2);
}
.backgroundcolorTheme2 {
  background: var(--theme2);
}
.backgroundcolorTheme1 {
  background: var(--theme1);
}
.colorWhite {
  color: var(--white);
}

.colorgrey {
  color: var(--grey);
}

.colorCyan {
  color: var(--cyan);
}

.colorBack {
  color: var(--grey);
}
.bxshadow {
  box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;
}

.borderRadius {
  border-radius: 15px;
}

.formDiv {
  height: calc(100vh - 110px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1%;
}
.formDiv::-webkit-scrollbar-track{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	background-color: #F5F5F5;
}
::-webkit-scrollbar-track{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	background-color: #F5F5F5;
}
::-webkit-scrollbar{
	width: 5px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb{
	background-color:var(--theme2);
	border: 2px solid var(--theme2);
  cursor: pointer;
}

input.form-control,
select.form-select {
  border-radius: 10px;
  height: 40px;
  border: 1px solid #e0dfdf;
  /* cursor: pointer; */
}
input.form-control:focus{
  border-color: var(--theme2);
  box-shadow: none;
}
select.form-select:focus {
  border-color: var(--theme2);
  box-shadow: none;
}

.MuiTablePagination-actions {
  display: none;
}

.MuiTablePagination-selectLabel,
.MuiTablePagination-displayedRows {
  margin-bottom: 0;
}

.css-ptck8z-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected {
  background-color: var(--theme1) !important;
  color: var(--white);
}

@media screen and (max-width: 768px) {
  .formDiv {
    height:100%;
    overflow: visible;
    padding: 0%;
  }
  .MuiPagination-ul li {
    margin-bottom: 3%;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,4CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,6CAA6C;EAC7C,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,0FAA0F;AAC5F;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;CACC,iDAAiD;CACjD,yBAAyB;AAC1B;AACA;CACC,iDAAiD;CACjD,yBAAyB;AAC1B;AACA;CACC,UAAU;CACV,yBAAyB;AAC1B;;AAEA;CACC,8BAA8B;CAC9B,+BAA+B;EAC9B,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[":root {\n  --theme1: #244394;\n  --theme2: #f15822;\n  --cyan: #1ea6d1;\n  --white: #ffffff;\n  --grey: #1f1f1f;\n  --black: #060b18;\n}\n\n@font-face {\n  font-family: \"Mulish\", sans-serif;\n  src: url(./Assets/Fonts/Mulish-Regular.ttf);\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Poppins\", sans-serif;\n  src: url(./Assets/Fonts/Poppins-Regular.ttf);\n}\n\nbody {\n  margin: 0;\n  font-family: \"Poppins\", sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 14px !important;\n}\n\n.font12 {\n  font-size: 12px;\n}\n\n.font16 {\n  font-size: 1.14em;\n}\n\n.font18 {\n  font-size: 1.29em;\n}\n\n.font20 {\n  font-size: 1.43em;\n}\n\n.colorTheme1 {\n  color: var(--theme1);\n}\n\n.colorTheme2 {\n  color: var(--theme2);\n}\n.backgroundcolorTheme2 {\n  background: var(--theme2);\n}\n.backgroundcolorTheme1 {\n  background: var(--theme1);\n}\n.colorWhite {\n  color: var(--white);\n}\n\n.colorgrey {\n  color: var(--grey);\n}\n\n.colorCyan {\n  color: var(--cyan);\n}\n\n.colorBack {\n  color: var(--grey);\n}\n.bxshadow {\n  box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n}\n\n.borderRadius {\n  border-radius: 15px;\n}\n\n.formDiv {\n  height: calc(100vh - 110px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 1%;\n}\n.formDiv::-webkit-scrollbar-track{\n\t-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n\tbackground-color: #F5F5F5;\n}\n::-webkit-scrollbar-track{\n\t-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n\tbackground-color: #F5F5F5;\n}\n::-webkit-scrollbar{\n\twidth: 5px;\n\tbackground-color: #F5F5F5;\n}\n\n::-webkit-scrollbar-thumb{\n\tbackground-color:var(--theme2);\n\tborder: 2px solid var(--theme2);\n  cursor: pointer;\n}\n\ninput.form-control,\nselect.form-select {\n  border-radius: 10px;\n  height: 40px;\n  border: 1px solid #e0dfdf;\n  /* cursor: pointer; */\n}\ninput.form-control:focus{\n  border-color: var(--theme2);\n  box-shadow: none;\n}\nselect.form-select:focus {\n  border-color: var(--theme2);\n  box-shadow: none;\n}\n\n.MuiTablePagination-actions {\n  display: none;\n}\n\n.MuiTablePagination-selectLabel,\n.MuiTablePagination-displayedRows {\n  margin-bottom: 0;\n}\n\n.css-ptck8z-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected {\n  background-color: var(--theme1) !important;\n  color: var(--white);\n}\n\n@media screen and (max-width: 768px) {\n  .formDiv {\n    height:100%;\n    overflow: visible;\n    padding: 0%;\n  }\n  .MuiPagination-ul li {\n    margin-bottom: 3%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
